import type { RouteObject } from 'react-router';
import { BankTransactionDetailPage } from './BankTransactionsPage';
import { HoldDetailPage } from './BillingPage';
import { InvoiceDetailPage } from './InvoicesPage';
import { JournalEntryPage, LedgerAccountPage } from './LedgerPage';
import { OrderDetailPage } from './OrdersPage';
import { PaymentDetailPage, RefundDetailPage } from './PaymentsPage';
import { PriceBookDetailPage } from './PricingPage';
import { PromotionDetailPage } from './PromotionsPage';
import { QuoteDetailPage } from './QuotesPage';

/** Detail routes (paths without a leading slash). */
export const COMMERCE_ROUTES: RouteObject[] = [
  { path: 'quotes/:quoteId', element: <QuoteDetailPage /> },
  { path: 'orders/:orderId', element: <OrderDetailPage /> },
  { path: 'payments/:paymentId', element: <PaymentDetailPage /> },
  { path: 'refunds/:refundId', element: <RefundDetailPage /> },
  { path: 'bank-transactions/:transactionId', element: <BankTransactionDetailPage /> },
  { path: 'holds/:holdId', element: <HoldDetailPage /> },
  { path: 'invoices/:invoiceId', element: <InvoiceDetailPage /> },
  { path: 'ledger/accounts/:accountId', element: <LedgerAccountPage /> },
  { path: 'ledger/journal/:entryId', element: <JournalEntryPage /> },
  { path: 'pricing/books/:bookId', element: <PriceBookDetailPage /> },
  { path: 'promotions/:promotionId', element: <PromotionDetailPage /> },
];
